<template>
  <div class="container">
    <br>
    <h5>Платежи</h5>
    <div class="container">
      <div class="row">
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="max-width: 400px">
            <input v-model="brandName"
                   @change="switchCountry"
                   type="text"
                   class="form-control"
                   placeholder="Плательщик"
                   aria-label="Плательщик"
                   aria-describedby="basic-addon2">
          </div>
        </div>
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="width: 140px">
            <select v-model="landCountryID"
                    @change="switchCountry"
                    class="form-control"
                    aria-label="Страна"
                    aria-describedby="basic-addon2">
              <option v-for="item in this.$store.getters.landCountries" :value="item.id">{{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="width: 220px">
            <select v-model="status"
                    @change="switchStatus"
                    class="form-control"
                    aria-label="Менеджер"
                    aria-describedby="basic-addon2">
              <option v-for="item in this.statuses" :value="item.id">{{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <!--        <div class="col-sm-auto">-->
        <!--          <div class="input-group mb-3" style="width: 220px">-->
        <!--            <select v-model="signerId"-->
        <!--                    @change="switchStatus"-->
        <!--                    class="form-control"-->
        <!--                    aria-label="Менеджер"-->
        <!--                    aria-describedby="basic-addon2">-->
        <!--              <option v-for="item in this.signers" :value="item.id">{{ item.display_name }}-->
        <!--              </option>-->
        <!--            </select>-->
        <!--          </div>-->
        <!--        </div>-->
        <div v-if="this.status === 'error'" style="margin-top: 10px;">
          Итого: <b> {{
            new Intl.NumberFormat('ru-ru', {
              minimumFractionDigits:
                  2
            }).format(totalDebt.toFixed(2))
          }} </b>
        </div>
      </div>

    </div>

    <div>
      <table class="table table-sm text-left payments-table">
        <thead>
        <th>ID</th>
        <th>Получатель</th>
        <th>Дата</th>
        <th>Номер</th>
        <th style="width: 200px">Плательщик</th>
        <th style="width: 300px">Назначение платежа</th>
        <th style="width: 100px">Комментарий</th>
        <th class="text-right">Сумма</th>
        </thead>
        <tbody>
        <tr v-for="p in payments">
          <td>
            <router-link :to="{name: 'payment', params:{
                            id: p.ID,
                        }}">{{ p.ID }}
            </router-link>
          </td>
          <td>{{ p.RecipientName }}</td>
          <td class="text-nowrap text-left" style="padding-right: 25px">{{
              new
              Date(p.Date).toISOString().split("T")[0]
            }}
          </td>
          <td>{{ p.Number }}</td>
          <td>{{ p.SenderName }}</td>
          <td style="word-wrap: anywhere">{{ p.Purpose }}</td>
          <td>{{ p.Comment }}</td>
          <td class="text-right">{{
              new Intl.NumberFormat('ru-ru', {
                minimumFractionDigits:
                    2
              }).format(p.Amount.toFixed(2))
            }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>

</template>

<script>
import axios from 'axios'

var d = new Date();

var this_year = d.getFullYear();
var this_month = d.getMonth();

this_month = this_month + 1;

function compare(a, b) {
  if (a.debt_sum > b.debt_sum)
    return -1;
  if (a.debt_sum < b.debt_sum)
    return 1;
  return 0;
}

export default {
  name: 'Payments',
  data() {
    return {
      landCountryID: "Russia",
      brandName: "",
      status: "error",
      payments: [],
      statuses: [
        {id: "error", name: "Не разнесен"},
        {id: "reconciled", name: "Разнесен"},
        {id: "returned", name: "Ошибочный"},
      ],
      signerId: 0,
      signers: [{id: 0, display_name: "Все"}],
    }
  },

  computed: {
    totalDebt: function () {
      return this.payments ? this.payments.map(el => el.Amount).reduce((a, b) => a + b, 0) : 0;
    },
  },

  beforeCreate() {
    axios.defaults.headers.authorization = this.$store.state.token;
  },

  created() {
    document.title = 'Платежи';

    let landCountryID = localStorage.getItem('landCountryID');

    if (landCountryID != null) {
      this.landCountryID = landCountryID
    } else {
      this.landCountryID = "landCountryID";
      localStorage.setItem('landCountryID', this.landCountryID);
    }

    let status = localStorage.getItem('paymentStatus');

    if (status != null) {
      this.status = status
    } else {
      this.status = "error";
      localStorage.setItem('paymentStatus', this.status);
    }

    this.search();
  },

  methods: {

    search() {
      axios.get('/payments', {
        params: {
          land_country_id: this.landCountryID,
          customer: this.brandName,
          status: this.status,
          signer_id: this.signerId,
        },
      })
          .then((res) => {
            // console.log(res.data);
            this.payments = res.data;

            // console.log(this.payments);

          })
          .catch(error => console.log(`Error: ${error}`));

    },


    switchCountry() {
      localStorage.setItem('landCountryID', this.landCountryID);
      this.search();
    },

    switchStatus() {
      localStorage.setItem('paymentStatus', this.status);
      this.search();
    },

  },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.payments-table {
  font-size: 14px;
  width: 1200px;
}

.invoice-table-td-medium {
  width: 95px;
}

.invoice-table-td-small {
  width: 60px;
}

.table-td-input {
  width: 70px;
}

.invoice-table-tr-height {
  vertical-align: middle;
  height: 36px;
}

.vertical-align-middle {
  vertical-align: middle;
}

.manager-td-width {
  width: 150px;
}

.td-padding-left-1 {
  padding-left: 40px;
}

.td-padding-left-2 {
  padding-left: 80px;
}

.td-padding-left-3 {
  padding-left: 120px;
}

.td-padding-left-4 {
  padding-left: 230px;
}

.no-spin::-webkit-inner-spin-button, .no-spin::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
  -moz-appearance: textfield !important;
}

</style>
